import * as _ from 'lodash';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from '../services/auth/auth.service';
import { ModalLoginService } from '../services/modal-login/modal-login.service';

@Injectable({
  providedIn: 'root'
})
export class DemoGuard  {

  constructor(
    private router: Router,
    private authService: AuthService,
    private modalLoginService: ModalLoginService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if(window['isProduction']) {
      return true;
    }

    if(route.queryParams.demo === "demo") {
      return this.authService.signin("demo@paybee.io", "demotest1").pipe(
        map((orgUser) => {
          this.authService.orgUser = orgUser;
          if(this.modalLoginService.modalRef) {
            this.modalLoginService.modalRef.close(true);
          }
          return this.router.parseUrl(this.router.url);
        }),
      ).toPromise().catch(() => {
        return this.router.parseUrl(this.router.url);
      });
    }
    return true;
  }
  
}
